import request from "@app/utils/apiRequest";
import {requestSaveInviteJobMailTemp} from "@app/services/InviteJobMailTemplateService";
import {ResponseCode} from "@app/constants/Common";
import {alertMessage} from "@app/constants/Messages";

export const SaveInviteJobMailTemp = (mailTemp, callback) => {
    requestSaveInviteJobMailTemp(mailTemp).then((res) => {
        if (res.sts_code === ResponseCode.SUCCESS) {
            callback(res.sts_code)
        } else {
            alertMessage(res.sts_code)
        }
    }).catch((error) => {
        console.log(`Error:${JSON.stringify(error)}`);
    })
}